import { lessonIframeOpenedHandler } from './handleIframe/lessonIframeOpenedObserver';

const main = () => {
  lessonIframeOpenedHandler();
};

main();
